import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { AddToBlacklistAPI } from '../api/blacklist/addtoblacklist/addtoblacklistapi';
import { AddToBlacklistRequest } from '../api/blacklist/addtoblacklist/addtoblacklistrequest';
import { AddToBlacklistResponse } from '../api/blacklist/addtoblacklist/addtoblacklistresponse';
import { AddToBlacklistAPIProcessorImpl } from '../processor/addtoblacklistapiprocessor';
import { APIProcessor } from '../processor/apiProcessor';
import { ProcessorFactoryImpl } from './processorfactory';
import { RemoveFromBlacklistAPIProcessorImpl } from '../processor/removefromblacklistapiprocessor';
import { RemoveFromBlacklistRequest } from '../api/blacklist/removefromblacklist/removefromblacklistrequest';
import { RemoveFromBlacklistResponse } from '../api/blacklist/removefromblacklist/removefromblacklistresponse';
import { RemoveFromBlacklistAPI } from '../api/blacklist/removefromblacklist/removefromblacklistapi';
import { ViewBlacklistRequest } from '../api/blacklist/viewblacklist/viewblacklistrequest';
import { ViewBlacklistResponse } from '../api/blacklist/viewblacklist/viewblacklistresponse';
import { ViewBlacklistAPIProcessorImpl } from '../processor/viewblacklistapiprocessor';
import { ViewBlacklistAPI } from '../api/blacklist/viewblacklist/viewblacklistapi';

export class BlacklistProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(BlacklistProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getAddToBlacklistAPIProcessor():APIProcessor<AddToBlacklistRequest, AddToBlacklistResponse>
    {
        this.logger.log("getAddToBlacklistAPIProcessor() invoked");
        return new AddToBlacklistAPIProcessorImpl(this.getContext(), new AddToBlacklistAPI(this.getHttpClient(), this.getContext()));
    }

     getRemoveFromBlacklistAPIProcessor():APIProcessor<RemoveFromBlacklistRequest, RemoveFromBlacklistResponse>
    {
        this.logger.log("getRemoveFromBlacklistAPIProcessor() invoked");
        return new RemoveFromBlacklistAPIProcessorImpl(this.getContext(), new RemoveFromBlacklistAPI(this.getHttpClient(), this.getContext()));
    }

    getViewBlacklistAPIProcessor():APIProcessor<ViewBlacklistRequest, ViewBlacklistResponse>
    {
        this.logger.log("getViewBlacklistAPIProcessor() invoked");
        return new ViewBlacklistAPIProcessorImpl(this.getContext(), new ViewBlacklistAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/blacklistprocessorfactory.tsx